import { useState } from "react";
import { TOKEN_KEY } from "@/lib/api";
import { AdminLogin } from "@/components/admin/AdminLogin";
import { AdminDashboard } from "@/components/admin/AdminDashboard";

export default function Admin() {
  const [token, setToken] = useState(localStorage.getItem(TOKEN_KEY));
  const login = (t) => { localStorage.setItem(TOKEN_KEY, t); setToken(t); };
  const logout = () => { localStorage.removeItem(TOKEN_KEY); setToken(null); };
  return (
    <div data-testid="admin-page" className="min-h-screen bg-cream-50 text-slate-800">
      {token ? <AdminDashboard onLogout={logout} /> : <AdminLogin onLogin={login} />}
    </div>
  );
}
